// extracted by mini-css-extract-plugin
module.exports = {"singleColumnSectionCardRoot":"single-column-section-card_singleColumnSectionCardRoot__MnrmR","pdp":"single-column-section-card_pdp__AuEaz"};